import React from "react";
import SkeletonSummary from "./SkeletonSummary";

const SkeletonArticle = () => {
  return (
    <div style={{ marginBottom: "1rem" }}>
      <SkeletonSummary />
    </div>
  );
};

export default SkeletonArticle;
